import { apiClient } from '@/shared/api'
import { buildQueryString } from '@/shared/utils/buildQueryString'
import type { Result } from '@/shared/types'
import type { ApiError } from '@/shared/types/errors'
import type { TagSearchResponse, TagCategory, TagStats, TagImportResult } from './types'

export async function searchTags(
  query: string,
  limit?: number,
  category?: number,
): Promise<Result<TagSearchResponse, ApiError>> {
  return apiClient.get(`/api/tags/search${buildQueryString({ q: query, limit, category })}`)
}

export async function fetchPopularTags(
  limit?: number,
  category?: number,
): Promise<Result<TagSearchResponse, ApiError>> {
  return apiClient.get(`/api/tags/popular${buildQueryString({ limit, category })}`)
}

export async function fetchTagCategories(): Promise<Result<readonly TagCategory[], ApiError>> {
  return apiClient.get('/api/tags/categories')
}

export async function fetchTagStats(): Promise<Result<TagStats, ApiError>> {
  return apiClient.get('/api/tags/stats')
}

export async function importTags(): Promise<Result<TagImportResult, ApiError>> {
  return apiClient.post('/api/tags/import')
}
